// A button that acts once on a tap and repeats while held. Nudge: tap and repeat are the same
// step. Rotate: a tap is the coarse step, holding repeats the FINE step (spec §3 `rot`).
// onRelease runs ONCE per press, however long it lasted (main.js: one undo step).
import { HOLD_MS, REPEAT_MS } from '../editor/gesture.js';

export function holdRepeat(button, { tap, repeat, onRelease }) {
  let holdTimer = null, repeatTimer = null, held = false, down = false;
  const stop = (fire) => {
    if (!down) return;
    down = false;
    clearTimeout(holdTimer); clearInterval(repeatTimer);
    if (fire && !held) tap();
    onRelease();
  };
  button.addEventListener('pointerdown', (e) => {
    if (e.button > 0) return;
    down = true; held = false;
    try { button.setPointerCapture(e.pointerId); } catch { /* synthetic pointer */ }
    holdTimer = setTimeout(() => { held = true; repeat(); repeatTimer = setInterval(repeat, REPEAT_MS); }, HOLD_MS);
  });
  button.addEventListener('pointerup', () => stop(true));
  button.addEventListener('pointercancel', () => stop(false));
  button.addEventListener('click', (e) => { if (e.detail === 0) { tap(); onRelease(); } });   // keyboard activation (Enter / Space)
}
